import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import BrandStagesFilterItems from "./BrandStagesFilterItems";

interface BrandStagesFilterCardProps {
  initialRange: [Dayjs, Dayjs];
  onGetData: (range: [Dayjs, Dayjs]) => void;
}

// No card container here, unlike the other tabs' filter cards - the Brand
// Stages spec (Section 3) lays its sections out without cards.
export default function BrandStagesFilterCard({ initialRange, onGetData }: BrandStagesFilterCardProps) {
  return (
    <Box>
      <BrandStagesFilterItems initialRange={initialRange} onGetData={onGetData} />
      <Typography sx={{ mt: 1.75, fontSize: 13.5, color: "#616161" }}>
        Only leads the brand marked as{" "}
        <Box component="strong" sx={{ fontWeight: 500, color: "#212121" }}>
          paid
        </Box>{" "}
        are counted, filtered by the date they were reported to the brand. Each lead counts at the highest stage it
        reached — stages are cumulative.
      </Typography>
    </Box>
  );
}
